// Accordion animation handler for smooth open/close transitions

function initAccordions(container = document) {
  const accordions = container.querySelectorAll('.accordion details');

  accordions.forEach(details => {
    // Skip if already initialized
    if (details.dataset.accordionInitialized) return;
    details.dataset.accordionInitialized = 'true';

    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');

    summary.addEventListener('click', function(e) {
      // If accordion is open, we need to animate the close
      if (details.open) {
        e.preventDefault();

        // Add closing class to trigger the closing animation
        details.classList.add('closing');

        // Function to close the accordion
        const closeAccordion = () => {
          details.classList.remove('closing');
          details.open = false;
        };

        // Wait for the animation to complete, then close
        const onTransitionEnd = (event) => {
          if (event.propertyName === 'grid-template-rows') {
            content.removeEventListener('transitionend', onTransitionEnd);
            closeAccordion();
          }
        };

        content.addEventListener('transitionend', onTransitionEnd);

        // Get the actual transition duration from CSS and add buffer for fallback
        const computedStyle = window.getComputedStyle(content);
        const duration = parseFloat(computedStyle.transitionDuration) * 1000 || 1000;
        setTimeout(() => {
          content.removeEventListener('transitionend', onTransitionEnd);
          if (details.classList.contains('closing')) {
            closeAccordion();
          }
        }, duration + 100);
      } else {
        // Opening animation - prevent default and control it manually
        e.preventDefault();

        // Add opening class to start from closed state
        details.classList.add('opening');
        details.open = true;

        // Force browser to acknowledge the closed state before animating
        content.offsetHeight;

        // Remove opening class to trigger animation to open state
        requestAnimationFrame(() => {
          details.classList.remove('opening');
        });
      }
    });
  });
}

// Use event delegation for View more/View less buttons (works with dynamically added elements)
document.addEventListener('click', function(e) {
  const button = e.target.closest('.accordion__view-toggle');
  if (!button) return;

  e.stopPropagation();
  const accordion = button.closest('.accordion');
  if (!accordion) return;

  if (button.classList.contains('accordion__view-more')) {
    // Expand the content
    accordion.classList.remove('accordion--semi-open');
    accordion.classList.add('accordion--expanded');
  } else if (button.classList.contains('accordion__view-less')) {
    // Collapse back to semi-open state
    accordion.classList.remove('accordion--expanded');
    accordion.classList.add('accordion--semi-open');

    // Scroll to the accordion content element (has the ID, positioned higher)
    const accordionContent = accordion.querySelector('.accordion__content');
    if (accordionContent && accordionContent.id) {
      document.getElementById(accordionContent.id).scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
});

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  initAccordions();
});

// Re-initialize when Shopify theme editor updates a section
document.addEventListener('shopify:section:load', function(event) {
  initAccordions(event.target);
});
